<template>
    <div class="container-fluid">
        <div class="d-flex p-2 justify-content-center align-items-center">
            <div>
                <h1>
                    <font-awesome-icon :icon="['fas', 'blender-phone']"/>
                    <span style="font-size: 40px !important;">QuickLy</span></h1>
                <p style="font-size: 11px;text-align: center;color: #7b7b7b;">by <a href="https://greenbull.group/"
                                                                                    target="_blank"
                                                                                    style="color:#7b7b7b;font-style: italic;">GreenBull
                    Group</a></p>
            </div>
        </div>
    </div>

</template>

<script>

    export default {
        data() {
            return {}
        },
        watch: {},
        computed: {},
        components: {},
        created: function () {

        },
        mounted: function () {
        },
        methods: {},
        name: 'HomePage'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
